import Button from "../element/button";
import Icon from "../element/icon";
import Row from "../element/row";
import useRequireAuth from "../hook/use.require.auth";

export default function CommonModalHeader({
  onBack,
  title,
  onShare,
  shareLabel = "   RM500",
}) {
  const { requireAuth } = useRequireAuth();
  return (
    <Row className={`common-modal-header ${onShare ? "has-share" : ""}`}>
      <Icon
        icon="ep:back"
        className="_svg back pointer"
        onClick={() => onBack?.()}
      />
      {title && <h4 className="_label title">{title}</h4>}
      {onShare ? (
        <Button className="_button share-reward" onClick={() => requireAuth(onShare, { modal: "referral" })}>
          <Icon
            icon="material-symbols:share-outline"
            className="_svg share-reward"
          />
          <span className="_label share-reward">{shareLabel}</span>
        </Button>
      ) : (
        <Icon
          icon="material-symbols:share-outline"
          className="_svg share transparent"
        />
      )}
    </Row>
  );
}
